module.exports = " <div class=mdl-grid> <div class=\"mdl-cell mdl-cell--4-col\"></div> <div class=\"mdl-cell mdl-cell--4-col mdl-card mdl-shadow--2dp\"> <div class=ga-form-title> <h2 class=ga-title-text>{{'delay.label.title' | label}}</h2> </div> <alert :message=msg :goto=next></alert> <div class=mdl-card__actions> </div> </div> <div class=\"mdl-cell mdl-cell--4-col\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/pages/Delay.vue
// module id = 334
// module chunks = 0